<template>
  <div id="section1">
    <div class="fondoWhite">
      <b-container fluid>
        <b-container>
          <br>
          <h2>
            <span
              v-for="(item, index) in p13s1title"
              :key="index"
            >
              <strong v-if="item.p13s1titleF">{{ item.p13s1titleT }}</strong>
              <span v-else>{{ item.p13s1titleT }}</span>
            </span>
          </h2>
          <br>
          <p class="text-left">
            {{ $t("p13s1Descrip") }}
            <strong>
              <a
                :href="p13s1Url"
                target="_blank"
              >{{ p13s1Link }}</a>
            </strong>
          </p>
          <br>
          <paginate
            ref="paginator"
            name="p13s1Ids"
            :list="p13s1Ids"
            :per="8"
          >
            <b-row>
              <b-col
                v-for="idv in paginated('p13s1Ids')"
                :key="idv.id"
                lg="4"
                md="6"
                sm="12"
              >
                <yt
                  :key="idv"
                  :idvideo="idv"
                  :activo="true"
                />
                <br>
              </b-col>
            </b-row>
          </paginate>
          <paginate-links
            for="p13s1Ids"
            :show-step-links="true"
            :simple="{
              prev: $t('prev'),
              next: $t('next')  
            }"
          />
        </b-container>
      </b-container>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "prev": "Prev",
    "next": "Next",
    "p13s1title": [
      {
        "p13s1titleF": true,
        "p13s1titleT": "Opinions about AICAD Business School: Real experiences of interns"
      }
    ]
    , "p13s1Descrip": "Learn about the experiences and opinions of other students who have done their internships through AICAD Business School and visit our "
  },
  "es":{
    "prev": "Anterior",
    "next": "Siguiente",
    "p13s1title": [
      {
        "p13s1titleF": true,
        "p13s1titleT": "Opiniones sobre AICAD Business School: Experiencias reales de estudiantes de práctica"
      }
    ]
    , "p13s1Descrip": "Conoce las experiencias y opiniones de otros estudiantes que han hecho sus prácticas por medio de AICAD Business School y visita nuestro "
  }
}
</i18n>

<script>
import yt from "@/components/utils/youtube";
export default {
    components: {
        yt
    },
    data() {
        return {
            p13s1Link: "YouTube Channel.",
            p13s1Url: "https://www.youtube.com/channel/UC1AZ0pvMZUCl6ete8j6KTZw",
            p13s1Urlrss:
        "https://www.googleapis.com/youtube/v3/search" +
        "?part=id" +
        "&channelId=UC1AZ0pvMZUCl6ete8j6KTZw" +
        "&order=date" +
        "&type=video" +
        "&key=" +
        process.env.VUE_APP_KEY_YOUTUBE,
            paginate: ["p13s1Ids"],
            p13s1Ids: []
        };
    },
    computed: {
        p13s1title() {
            return this.$t("p13s1title");
        }
    },
    mounted() {
        if (process.env.NODE_ENV === "production") {
            this.buscarVideos();
        } else {
            this.p13s1Ids = [
                "EQvVA1pIYSo",
                "F4QOqU_zFbQ",
                "WkM5XiMGwq0",
                "6X-BK6puwvc",
                "fLs6_xU3zm0",
                "mRNxM1ao1IU"
            ];
        }
    },
    methods: {
        rellamadaBuscarVideo: async function(nextPage, config) {
            var nt = "&pageToken=" + nextPage;
            const result = await this.axios
                .get(this.p13s1Urlrss + nt, config)
                .then(response => response.data);
            var obj = JSON.parse(JSON.stringify(result));
            for (let index = 0; index < obj.items.length; index++) {
                const element = obj.items[index].id.videoId;
                this.p13s1Ids.push(element);
            }
            var next_ = "";
            try {
                next_ = obj.nextPageToken;
            } catch (e) {
                next_ = "";
            }
            return next_;
        },
        buscarVideos: async function() {
            var config = {
                headers: {
                    "cache-control": "no-cache"
                }
            };
            const result = await this.axios
                .get(this.p13s1Urlrss, config)
                .then(response => response.data)
                .catch(error => {
                    console.log(error);
                    this.p13s1Ids = [
                        "EQvVA1pIYSo",
                        "F4QOqU_zFbQ",
                        "WkM5XiMGwq0",
                        "6X-BK6puwvc",
                        "fLs6_xU3zm0",
                        "mRNxM1ao1IU"
                    ];
                });
            var obj = JSON.parse(JSON.stringify(result));
            for (let index = 0; index < obj.items.length; index++) {
                const element = obj.items[index].id.videoId;
                this.p13s1Ids.push(element);
            }
            var nextPage = "";
            try {
                var total = obj.pageInfo.totalResults;
                var pag = obj.pageInfo.resultsPerPage;
                if (pag > 0) {
                    pag = Math.round(total / pag) - 1;
                    nextPage = obj.nextPageToken;
                    for (let index = 0; index < pag; index++) {
                        nextPage = await this.rellamadaBuscarVideo(nextPage, config);
                    }
                }
            } catch (e) {
                nextPage = "";
            }
        }
    }
};
</script>

<style>
.paginate-links {
  width: 100%;
  list-style: none;
  text-align: center;
}
.paginate-links li {
  display: inline;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}

.paginate-links li a {
	border-radius: 22px !important;
	border-color: #009090 !important;
	background-color: #009090 !important;
	color: whitesmoke !important;
	margin: 0 auto;
	letter-spacing: 2px;
	padding: 0.4em 2em !important;
	cursor: pointer;
	font-size: 1.1em !important;
	transition: 0.3s !important;
}

.paginate-links li a:hover {
  opacity: 0.85;
  background-color: #00c8c3 !important;
  text-decoration: inherit !important;
  transform: scale(1.1);
}

.paginate-result {
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
}
</style>
